import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export const BRT_TIME_ZONE = "America/Sao_Paulo"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

function parseDateValue(value: Date | string | number | null | undefined): Date | null {
  if (value == null) return null
  if (value instanceof Date) {
    return Number.isFinite(value.getTime()) ? value : null
  }
  if (typeof value === "string") {
    const trimmed = value.trim()
    if (!trimmed) return null
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
      const dateOnly = new Date(`${trimmed}T12:00:00-03:00`)
      return Number.isFinite(dateOnly.getTime()) ? dateOnly : null
    }
    const parsed = new Date(trimmed)
    return Number.isFinite(parsed.getTime()) ? parsed : null
  }
  if (typeof value === "number") {
    const parsed = new Date(value)
    return Number.isFinite(parsed.getTime()) ? parsed : null
  }
  return null
}

export function getBrtDateYmd(value: Date | string | number = new Date()): string {
  const parsed = parseDateValue(value)
  if (!parsed) return ""

  return new Intl.DateTimeFormat("en-CA", {
    timeZone: BRT_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(parsed)
}

export function toBrtDateInputValue(value: Date | string | number | null | undefined): string {
  const parsed = parseDateValue(value)
  if (!parsed) return ""
  return getBrtDateYmd(parsed)
}

export function formatBrtDate(
  value: Date | string | number | null | undefined,
  options: Intl.DateTimeFormatOptions = {},
): string {
  const parsed = parseDateValue(value)
  if (!parsed) return ""
  return parsed.toLocaleDateString("pt-BR", { timeZone: BRT_TIME_ZONE, ...options })
}

export function formatBrtTime(
  value: Date | string | number | null | undefined,
  options: Intl.DateTimeFormatOptions = {},
): string {
  const parsed = parseDateValue(value)
  if (!parsed) return ""
  return parsed.toLocaleTimeString("pt-BR", { timeZone: BRT_TIME_ZONE, ...options })
}

export function formatBrtDateTime(
  value: Date | string | number | null | undefined,
  options: Intl.DateTimeFormatOptions = {},
): string {
  const parsed = parseDateValue(value)
  if (!parsed) return ""
  return parsed.toLocaleString("pt-BR", { timeZone: BRT_TIME_ZONE, ...options })
}
